import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Collapse, Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import notificationsSelectors from 'store/notifications/notifications.selectors';

import { useAppContext } from 'Main';
import NavbarVerticalMenuItem from './NavbarVerticalMenuItem';

const CollapseItems = ({ route, hasNotification = false }) => {
  const { pathname } = useLocation();

  const openCollapse = childrens => {
    const checkLink = children => {
      if (children.to === pathname) {
        return true;
      }
      return (
        Object.prototype.hasOwnProperty.call(children, 'children') &&
        children.children?.some(checkLink)
      );
    };
    return childrens.some(checkLink);
  };

  const [open, setOpen] = useState(openCollapse(route.children));

  return (
    <Nav.Item as="li">
      <Nav.Link
        onClick={() => {
          setOpen(!open);
        }}
        className={classNames('dropdown-indicator cursor-pointer', {
          'text-500': !route.active
        })}
        aria-expanded={open}
        // {...route}
      >
        <NavbarVerticalMenuItem
          route={route}
          hasNotification={hasNotification}
        />
      </Nav.Link>
      <Collapse in={open}>
        <Nav className="flex-column nav" as="ul">
          <NavbarVerticalMenu routes={route.children} />
        </Nav>
      </Collapse>
    </Nav.Item>
  );
};

CollapseItems.propTypes = {
  hasNotification: PropTypes.bool,
  route: PropTypes.shape({
    name: PropTypes.string.isRequired,
    icon: PropTypes.string,
    children: PropTypes.array.isRequired,
    active: PropTypes.bool
  }).isRequired
};

const NavbarVerticalMenu = ({ routes }) => {
  const {
    config: { showBurgerMenu },
    setConfig
  } = useAppContext();

  const notifications = useSelector(notificationsSelectors.notifications);
  const handleNavItemClick = () => {
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };

  return routes.map((route, index) => {
    const hasNotification = route.subscription.some(value =>
      notifications.includes(value)
    );

    if (!route.children) {
      const isExternal = route.external;

      return (
        <Nav.Item
          as="li"
          key={`${route.name || index}-${route.to || index}`}
          onClick={handleNavItemClick}
        >
          {isExternal ? (
            <a
              href={route.externalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link"
            >
              <NavbarVerticalMenuItem
                route={route}
                hasNotification={hasNotification}
              />
            </a>
          ) : (
            <NavLink
              end={route.exact}
              to={route.to}
              onClick={() =>
                route.name === 'Modal'
                  ? setConfig('openAuthModal', true)
                  : undefined
              }
              className={({ isActive }) =>
                isActive && route.to !== '#!' ? 'active nav-link' : 'nav-link'
              }
            >
              <NavbarVerticalMenuItem
                route={route}
                hasNotification={hasNotification}
              />
            </NavLink>
          )}
        </Nav.Item>
      );
    }

    return (
      <CollapseItems
        route={route}
        key={route.name}
        hasNotification={hasNotification}
      />
    );
  });
};

NavbarVerticalMenu.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape(NavbarVerticalMenuItem.propTypes))
    .isRequired
};

export default NavbarVerticalMenu;
